import PropTypes from 'prop-types';
import {useState} from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Modal, Message} from 'semantic-ui-react';

import {useHttpClient} from 'hooks';
import httpClient from 'httpClient';
import {addSuccessMessage} from 'state/actions';

import DeleteShortUrlModal from './DeleteShortUrlModal';
import ShortUrlForm from './ShortUrlForm';

const ShortUrlManagementModal = ({url, open, onUpdate, onClose}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isUpdating, setIsUpdating] = useState(false);
  const host = new URL(url.url).host;

  const {data: shortUrl, error, loading: isFetchingShortUrl} = useHttpClient({
    url: `/api/web-redirector/${host}/short-urls/${url.id}`,
    method: 'GET',
  });

  async function updateShortUrl(formValues) {
    setIsUpdating(true);
    try {
      await httpClient.patch(`/api/web-redirector/${host}/short-urls/${url.id}`, {
        ...formValues,
      });

      setIsUpdating(false);
      if (onUpdate) {
        onUpdate();
      }

      dispatch(addSuccessMessage('The short URL for was updated successfully'));
      history.push('/short-urls');
    } catch {
      setIsUpdating(false);
    }
  }

  return (
    <Modal
      open={open}
      closeOnDimmerClick={!isUpdating && !isFetchingShortUrl}
      closeOnDocumentClick={!isUpdating && !isFetchingShortUrl}
      closeIcon={!isUpdating && !isFetchingShortUrl}
      onClose={onClose}
    >
      <Modal.Header>Configuration of {url.url}</Modal.Header>
      <Modal.Content>
        {error ? (
          <Message error>There was a problem while fetching details of the short URL.</Message>
        ) : (
          <>
            <ShortUrlForm
              initialValues={shortUrl?.shortUrl}
              loading={isFetchingShortUrl || isUpdating}
              onSubmit={updateShortUrl}
              allowOwnerChange
            />
            <DeleteShortUrlModal url={url.url} id={url.id} targetUrl={url.targetUrl} />
          </>
        )}
      </Modal.Content>
    </Modal>
  );
};

ShortUrlManagementModal.propTypes = {
  url: PropTypes.object.isRequired,
  open: PropTypes.bool,
  onUpdate: PropTypes.func,
  onClose: PropTypes.func,
};

ShortUrlManagementModal.defaultProps = {
  open: false,
  onUpdate: null,
  onClose: null,
};

export default ShortUrlManagementModal;
